import React from 'react';
import { UploadFileDto } from 'dto/upload-file.dto';
import { TableUtils } from 'pages/private/components/table-utils';
import { IBasicTableColumn } from 'ui-lib';
import { IRecordPickerFormItemProps, RecordPickerFormItem } from 'pages/private/components/record-picker';

const getArtifactColumns = (accountUuid?: string): IBasicTableColumn[] => [
    TableUtils.createBasicFilterColumn<UploadFileDto>({ title: 'File Name', key: 'fileName' }),
    TableUtils.createTruncatedTextColumn({ title: 'Description', key: 'description' }),
    TableUtils.createBasicFilterTimeColumn<UploadFileDto>({ title: 'Updated At', key: 'updatedAt' }),
];

export interface IArtifactsPickerFormItemProps
    extends Omit<IRecordPickerFormItemProps<UploadFileDto>, 'columns' | 'renderRecordTag'> {
    accountUuid?: string;
}

export const ArtifactsPickerFormItem = (props: IArtifactsPickerFormItemProps): JSX.Element => {
    const { accountUuid, ...itemProps } = props;

    return (
        <RecordPickerFormItem<UploadFileDto>
            {...itemProps}
            renderRecordTag={(artifact) => artifact.fileName}
            columns={getArtifactColumns(accountUuid)}
        />
    );
};
